var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Members"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4298 21.2075C11.1732 21.2075 7.72256 17.7569 7.72256 13.5002C7.72256 9.24363 11.1732 5.79297 15.4298 5.79297C19.6864 5.79297 23.1371 9.24363 23.1371 13.5002C23.1371 17.7569 19.6864 21.2075 15.4298 21.2075ZM15.4299 22.9199C22.5243 22.9199 28.2754 28.671 28.2754 35.7654V39.1908C28.2754 39.6638 27.892 40.0472 27.419 40.0472H3.44084C2.96788 40.0472 2.58447 39.6638 2.58447 39.1908V35.7654C2.58447 28.671 8.33558 22.9199 15.4299 22.9199Z",
    fill: "#56A74A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7609 21.545C27.0406 21.545 26.562 21.0066 26.562 20.3461C26.562 19.6856 27.0406 19.1472 27.7609 19.1472H31.3576V15.5505C31.3576 14.8301 31.8961 14.3516 32.5566 14.3516C33.2171 14.3516 33.7555 14.8301 33.7555 15.5505V19.1472H37.3522C38.0725 19.1472 38.5511 19.6856 38.5511 20.3461C38.5511 21.0066 38.0725 21.545 37.3522 21.545H33.7555V25.1417C33.7555 25.8621 33.2171 26.3407 32.5566 26.3407C31.8961 26.3407 31.3576 25.8621 31.3576 25.1417V21.545H27.7609Z",
    fill: "#56A74A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/Members.e0507e0338934e3ed29c52bccdc96db7.svg";
export { ForwardRef as ReactComponent };